import moment from 'moment';

import { CALL_API } from 'middleware/api';

/**
 * The report endpoints return only their most recent rows unless a period is
 * requested, so every fetch states the period it needs. Bounds are widened to
 * whole days in the user's timezone, which is how the UI filters the rows.
 */
export const buildReportEndpoint = (organizationId, path, range = {}) => {
  const params = new URLSearchParams();
  const from = range.dateFrom && moment(range.dateFrom);
  const to = range.dateTo && moment(range.dateTo);
  if (from && from.isValid()) params.set('from', from.startOf('day').toISOString());
  if (to && to.isValid()) params.set('to', to.endOf('day').toISOString());
  const query = params.toString();
  return `v1/organizations/${organizationId}/${path}${query ? `?${query}` : ''}`;
};

export const GET_REPORTS_URL_REQUEST = 'GET_REPORTS_URL_REQUEST';
export const GET_REPORTS_URL_SUCCESS = 'GET_REPORTS_URL_SUCCESS';
export const GET_REPORTS_URL_FAILURE = 'GET_REPORTS_URL_FAILURE';

export const GET_WEIGHT_CHANGE_DATA_REQUEST = 'GET_WEIGHT_CHANGE_DATA_REQUEST';
export const GET_WEIGHT_CHANGE_DATA_SUCCESS = 'GET_WEIGHT_CHANGE_DATA_SUCCESS';
export const GET_WEIGHT_CHANGE_DATA_FAILURE = 'GET_WEIGHT_CHANGE_DATA_FAILURE';

export const GET_BMI_DATA_REQUEST = 'GET_BMI_DATA_REQUEST';
export const GET_BMI_DATA_SUCCESS = 'GET_BMI_DATA_SUCCESS';
export const GET_BMI_DATA_FAILURE = 'GET_BMI_DATA_FAILURE';

export const GET_TARGET_WEIGHT_DATA_REQUEST = 'GET_TARGET_WEIGHT_DATA_REQUEST';
export const GET_TARGET_WEIGHT_DATA_SUCCESS = 'GET_TARGET_WEIGHT_DATA_SUCCESS';
export const GET_TARGET_WEIGHT_DATA_FAILURE = 'GET_TARGET_WEIGHT_DATA_FAILURE';

export const GET_WBGT_DATA_REQUEST = 'GET_WBGT_DATA_REQUEST';
export const GET_WBGT_DATA_SUCCESS = 'GET_WBGT_DATA_SUCCESS';
export const GET_WBGT_DATA_FAILURE = 'GET_WBGT_DATA_FAILURE';

export const getReportsUrl = organizationId => {
  return {
    [CALL_API]: {
      types: [GET_REPORTS_URL_REQUEST, GET_REPORTS_URL_SUCCESS, GET_REPORTS_URL_FAILURE],
      authenticated: true,
      endpoint: `v1/organizations/${organizationId}/reporturl`,
      method: 'GET',
    },
  };
};

export const getWeightChangeData = (organizationId, range) => {
  return {
    [CALL_API]: {
      types: [GET_WEIGHT_CHANGE_DATA_REQUEST, GET_WEIGHT_CHANGE_DATA_SUCCESS, GET_WEIGHT_CHANGE_DATA_FAILURE],
      authenticated: true,
      endpoint: buildReportEndpoint(organizationId, 'weightchanges', range),
      method: 'GET',
    },
  };
};

export const getBmiData = (organizationId, range) => {
  return {
    [CALL_API]: {
      types: [GET_BMI_DATA_REQUEST, GET_BMI_DATA_SUCCESS, GET_BMI_DATA_FAILURE],
      authenticated: true,
      endpoint: buildReportEndpoint(organizationId, 'bmidata', range),
      method: 'GET',
    },
  };
};

export const getTargetWeightData = (organizationId, range) => {
  return {
    [CALL_API]: {
      types: [GET_TARGET_WEIGHT_DATA_REQUEST, GET_TARGET_WEIGHT_DATA_SUCCESS, GET_TARGET_WEIGHT_DATA_FAILURE],
      authenticated: true,
      endpoint: buildReportEndpoint(organizationId, 'targetweightdata', range),
      method: 'GET',
    },
  };
};

export const getWbgtData = (organizationId, range) => {
  return {
    [CALL_API]: {
      types: [GET_WBGT_DATA_REQUEST, GET_WBGT_DATA_SUCCESS, GET_WBGT_DATA_FAILURE],
      authenticated: true,
      endpoint: buildReportEndpoint(organizationId, 'wbgtdata', range),
      method: 'GET',
    },
  };
};
